module.exports = "pegasus_template/assets/impact-card.png";